<template>
    <button class="more-button" @click="onClick" :disabled="disabled">
        <div class="more-button__text" :class="{ 'more-button__text--loading': isLoading }">
            {{ isLoading ? 'Загрузка...' : 'Еще' }}
            <IconCircleArrows v-if="!isLoading" />
        </div>
    </button>
</template>

<script>
import IconCircleArrows from '@/views/track/icons/IconCircleArrows.vue';

export default {
    name: 'MoreButton',
    components: {
        IconCircleArrows,
    },

    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.more-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: urem(8);
    background: none;
    border: none;
    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    @include on-desktop {
        margin-top: 0;
        background: rgba(247, 249, 252, 1);
        border-radius: urem(16);
        width: urem(252);
    }

    &__text {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: urem(8);
        font-size: urem(14);
        font-weight: 600;
        color: rgba(19, 22, 20, 1);
        line-height: urem(48);
        border: urem(1) solid rgba(70, 99, 171, 1);
        padding: 0 urem(20);
        border-radius: urem(10);
        color: rgba(70, 99, 171, 1);

        &--loading {
            animation: blink 1s linear infinite;
            cursor: not-allowed;
        }

        @include on-desktop {
            width: urem(126);
        }

        :deep(svg) {
            width: urem(20);
            height: urem(20);
        }
    }
}

@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
}
</style>
